import axios from 'axios';
import utils from '../config/utils';
// import VueCookies from 'vue-cookies';
// import store from '../store'
axios.defaults.withCredentials = true; //允许跨域携带cookies

// 环境相关变量统一由 .env / .env.development / .env.test 配置，打包自动区分环境
var HOST = process.env.VUE_APP_HOST;
var IMG_SERVER = process.env.VUE_APP_IMG_SERVER;
var LOGIN_SERVER = process.env.VUE_APP_LOGIN_SERVER; // 信息服务中心登录 // eslint-disable-line no-unused-vars
var APPS_SERVIER = process.env.VUE_APP_APPS_SERVIER; //信息服务中心api
var XUEXI_SERVER = process.env.VUE_APP_XUEXI_SERVER; //新版在线学习
var XUEXI_HOST = process.env.VUE_APP_XUEXI_HOST; //新版在线学习HOST
var JIAOYU_SCHOOL = process.env.VUE_APP_JIAOYU_SCHOOL; // 院校主页
var StudyCode = process.env.VUE_APP_STUDY_CODE; //研学旅行学校code
var HZ_CODE = process.env.VUE_APP_HZ_CODE; // 杭职院code
var QMT_SERVER = process.env.VUE_APP_QMT_SERVER;
var YXT_GW = process.env.VUE_APP_YXT_GW;

// 部署模式标识：hzvtc 单独部署时为 'hzvtc'，其余环境为空
var DEPLOY = process.env.VUE_APP_DEPLOY || '';

// 以下 CODE 各环境一致
var PARTY_CODE = '100004'; // 党建CODE
var SXYXLX_CODE = '100046'; // 山西研学旅行CODE
var YXLX_CODE = '100041'; // 成都、湖北研学旅行CODE
var HLJNY_CODE = '100067'; // 黑龙江农业经济职业学院

function handleFunc(res) {
    let pathname = window.location.pathname;
    if (
        res.code == '2001' &&
        ((!(pathname.indexOf('/hzvtc') > -1) && !(pathname.indexOf('/custom') > -1) && !(pathname.indexOf('/Page404') > -1)) || pathname.indexOf('sxyxlx') > -1)
    ) {
        if (pathname.indexOf('/nologin/') > -1) return;
        utils.removeUserInfo();
        let code = utils.getUrlSchoolCode(window.location.pathname) || '';
        if (code) {
            window.open(`${APPS_SERVIER}/api/redirect?school_code=${code}&from=${window.location.href}`, '_self');
        }
    }
}

//请求发送拦截
axios.interceptors.request.use(
    (request) => {
        return request;
    },
    function (error) {
        return Promise.reject(error);
    }
);

const request = (method, url, params, needLogin) => {
    if (needLogin) params.login_sign = '';

    if (method == 'post') {
        return axios
            .post(url, params)
            .then((res) => res.data)
            .then((res) => {
                handleFunc(res);
                return res;
            });
    } else if (method == 'get') {
        return axios
            .get(url, { params })
            .then((res) => res.data)
            .then((res) => {
                handleFunc(res);
                return res;
            });
    }
};
export default {
    IMG_SERVER: IMG_SERVER,
    HOST: HOST,
    LOGIN_SERVER: LOGIN_SERVER,
    APPS_SERVIER: APPS_SERVIER,
    XUEXI_SERVER: XUEXI_SERVER,
    XUEXI_HOST: XUEXI_HOST,
    JIAOYU_SCHOOL: JIAOYU_SCHOOL,
    StudyCode: StudyCode,
    HZ_CODE: HZ_CODE,
    PARTY_CODE: PARTY_CODE,
    QMT_SERVER: QMT_SERVER,
    YXT_GW: YXT_GW,
    SXYXLX_CODE: SXYXLX_CODE,
    YXLX_CODE: YXLX_CODE,
    HLJNY_CODE: HLJNY_CODE,
    DEPLOY: DEPLOY,
    //测评列表
    assessList(params) {
        return request('get', XUEXI_SERVER + '/api/my/tk/exam', params);
    },
    //测评记录
    assessLoglists(params) {
        return request('get', XUEXI_SERVER + '/api/my/tk/exam/record', params);
    },
    //测评详情
    assessGet(params) {
        return request('get', XUEXI_SERVER + '/api/my/tk/exam/' + params.id, params.data);
    },
    //用户测评答题卡
    assessCard(params) {
        return request('get', XUEXI_SERVER + '/api/my/tk/exam/card', params);
    },
    //测评试题查看
    questionGetbyassess(params) {
        return request('get', XUEXI_SERVER + '/api/my/tk/exam/question', params);
    },
    //提交测评
    assessModify(params) {
        return request('post', XUEXI_SERVER + '/api/my/tk/exam', params);
    },
    //测评结果页答题卡
    assessResultCard(params) {
        return request('get', XUEXI_SERVER + '/api/my/tk/exam/mark_card', params);
    },
    //测评问答题评分
    assessScore(params) {
        return request('post', XUEXI_SERVER + '/api/my/tk/exam/' + params.id, params.data, true);
    },
    //学习中心-测评答题文件流下载
    assessFileGet(params) {
        let url = XUEXI_SERVER + '/api/my/tk/exam/download?';
        for (let key in params) {
            url += key + '=' + params[key] + '&';
        }
        return axios
            .request({
                url: url,
                responseType: 'blob',
                method: 'get',
            })
            .then((res) => res.data);
    },

    // V2.0接口
    // 信息服务中心 - 获取图片验证码
    getAppsImageCaptcha(params) {
        return request('get', APPS_SERVIER + '/api/captcha', params);
    },
    // 信息服务中心 - 获取短信验证码
    getAppsSmsCaptcha(params) {
        return request('get', APPS_SERVIER + '/api/sms/send', params);
    },
    // 信息服务中心 - 获取学校信息
    getAppsSchoolInfo(params) {
        return request('get', APPS_SERVIER + '/api/login/info', params);
    },
    // 信息服务中心 - 官网注册
    postAppsRegister(params) {
        return request('post', APPS_SERVIER + '/api/register', params);
    },
    // 信息服务中心 - 登录
    postAppsLogin(params) {
        return request('post', APPS_SERVIER + '/api/login', params);
    },
    // 信息服务中心 - 退出登录
    postAppsLogout(params) {
        return request('post', APPS_SERVIER + '/api/logout', params);
    },
    // 信息服务中心 - 修改个人密码
    postAppsEditPassword(params) {
        return request('post', APPS_SERVIER + '/api/user/password', params);
    },
    // 信息服务中心 - 重置密码
    postAppsResetPassword(params) {
        return request('post', APPS_SERVIER + '/api/reset', params);
    },
    // 信息服务中心 - 重置密码
    getAppsUserInfo(params) {
        return request('get', APPS_SERVIER + '/api/user/info', params);
    },
    // 信息服务中心 - 绑定/换绑手机号
    updateUserPhone(params) {
        return request('post', APPS_SERVIER + '/api/user/phone', params);
    },
    // 信息服务中心 - 解绑微信
    getWechatUnbind(params) {
        return request('post', APPS_SERVIER + '/api/user/unbind', params);
    },
    // 课程分类
    getCourseCategory(params) {
        return request('get', XUEXI_SERVER + '/api/course/category', params);
    },
    // 获取班级内课程分类
    getClassCategory(params) {
        return request('get', XUEXI_SERVER + '/api/my/course/category', params);
    },
    // 课程学习日志新增
    addCourseLog(params) {
        return request('get', XUEXI_SERVER + '/api/course/log/add', params);
    },
    // 课程章节详情
    getCourseChapterDetail(params) {
        return request('get', XUEXI_SERVER + '/api/course/' + params.id + '/chapter', params.data);
    },
    // 课程章节播放信息
    getCoursePlay(params) {
        return request('get', XUEXI_SERVER + '/api/course/course/' + params.id + '/play', params.data);
    },
    // 课程列表
    getCourseLists(params) {
        return request('get', XUEXI_SERVER + '/api/course/course', params);
    },
    // 课程详情
    getCourseDetails(params) {
        return request('get', XUEXI_SERVER + '/api/course/course/' + params.id, params.data);
    },
    // 课程讲师信息
    getCourseTeacher(params) {
        return request('get', XUEXI_SERVER + '/api/course/teacher', params);
    },
    // 课程详情-获取课程评价列表
    getCourseComment(params) {
        return request('get', XUEXI_SERVER + '/api/course/comment', params);
    },
    // 课程详情-添加课程评价
    addCourseComment(params) {
        return request('post', XUEXI_SERVER + '/api/course/comment', params);
    },
    // 课程详情-删除课程评价
    removeCourseComment(params) {
        return request('post', XUEXI_SERVER + '/api/course/comment/' + params.id, params.data);
    },
    // 课程详情-添加课程笔记
    addCourseNote(params) {
        return request('post', XUEXI_SERVER + '/api/my/course/note', params);
    },
    // 学习中心-我的课程列表
    getUserCourseList(params) {
        return request('get', XUEXI_SERVER + '/api/my/course', params);
    },
    // 学习中心-我的证书列表
    getUserCert(params) {
        return request('get', APPS_SERVIER + '/api/user/cert', params);
    },
    // 学习中心-我的笔记列表
    getUserCourseNote(params) {
        return request('get', XUEXI_SERVER + '/api/my/course/note', params);
    },
    // 学习中心-修改、删除我的笔记
    editUserCourseNote(params) {
        return request('post', XUEXI_SERVER + '/api/my/course/note/' + params.id, params.data);
    },
    // 学习中心-我的练习列表
    getUserExercisesList(params) {
        return request('get', XUEXI_SERVER + '/api/my/tk/exercises', params);
    },
    // 学习中心-我的练习答题卡
    getUserExercisesCard(params) {
        return request('get', XUEXI_SERVER + '/api/my/tk/exercises/card', params);
    },
    // 学习中心-我的练习答题卡
    getUserExercisesDetails(params) {
        return request('get', XUEXI_SERVER + '/api/my/tk/exercises/' + params.id, params.data);
    },
    // 学习中心-我的练习题详情
    getUserExercisesQuestion(params) {
        return request('get', XUEXI_SERVER + '/api/my/tk/exercises/question', params);
    },
    // 学习中心-提交我的练习
    postUserExercisesSubmit(params) {
        return request('post', XUEXI_SERVER + '/api/my/tk/exercises', params);
    },
    // 学习中心-获取腾讯云视频上传签名
    tencentSign(params) {
        return request('get', XUEXI_SERVER + '/api/tencent/vod/sign', params);
    },
    // 学习中心-我的学习记录列表
    getUserLearnLog(params) {
        return request('get', XUEXI_SERVER + '/api/my/learn/log', params);
    },
    //课程资源pdf文件流下载v2
    courseFilePreview(params) {
        return axios
            .request({
                url: XUEXI_SERVER + '/api/course/course/preview',
                data: params,
                responseType: 'blob',
                method: 'post',
            })
            .then((res) => res.data);
    },
    //学习中心-练习文件流预览
    fileUpload(params) {
        return axios
            .request({
                url: XUEXI_SERVER + '/api/upload/file',
                method: 'post',
                data: params,
            })
            .then((res) => res.data);
    },
    //学习中心-练习答题文件流下载
    attachmentFileGet(params) {
        let url = XUEXI_SERVER + '/api/my/tk/exercises/attachment?';
        for (let key in params) {
            url += key + '=' + params[key] + '&';
        }
        return axios
            .request({
                url: url,
                responseType: 'blob',
                method: 'get',
            })
            .then((res) => res.data);
    },

    getStudyTrip(params) {
        return request('get', XUEXI_SERVER + '/api/yanxue/course/index', params);
    },
    getFamousClasses(params) {
        return request('get', XUEXI_SERVER + '/api/yanxue/course/index', params);
    },
    multiAide(params) {
        return request('get', XUEXI_SERVER + '/api/yanxue/material/index', params);
    },
    // 学习数据 - 学习概况
    getStudySummary(params) {
        return request('get', XUEXI_SERVER + '/api/my/stat/summary', params);
    },
    // 学习数据 - 学习课程统计
    getStudyCourse(params) {
        return request('get', XUEXI_SERVER + '/api/my/stat/report2', params);
    },
    // 学习数据 - 学习时长统计
    getStudyTime(params) {
        return request('get', XUEXI_SERVER + '/api/my/stat/report1', params);
    },
    // 获取课程分类
    getCategoryList(params) {
        return request('get', XUEXI_SERVER + '/api/sz/school/course/category', params);
    },
    // 获取课程列表
    getCourseList(params) {
        return request('get', XUEXI_SERVER + '/api/sz/school/course', params);
    },
    // 获取课程素材列表
    getCourseMaterial(params) {
        return request('get', XUEXI_SERVER + '/api/sz/school/course/list', params);
    },
    // 学习设置-获取防挂机设置
    getStudyConfig(params) {
        return request('get', XUEXI_SERVER + '/api/school/course/setting', params);
    },
    // 文档资源
    getQmtCourse(params) {
        return request('get', QMT_SERVER + '/api/site/news', params);
    },
    // 获取素材简介
    getMaterialIntro(params) {
        return request('get', XUEXI_SERVER + '/api/course/course/material', params);
    },

    // 融媒体运营 - 文章列表
    getRmtNewsList(params) {
        return request('get', QMT_SERVER + '/api/cms/news', params);
    },
    // 融媒体运营 - 文章详情
    getRmtNewsDetail(params) {
        return request('get', QMT_SERVER + '/api/cms/news/' + params.id, params);
    },
};
